export {
  Illustration,
  HERO_NAMES,
  SPOT_NAMES,
  MIX_MATCH_NAMES,
  EMPTY_STATE_NAMES,
} from './Illustration';

export type { IllustrationProps } from './Illustration';
